import {CitySlug, citySlugToInvestmentsMapCityQuery, getCityOption} from "../../../../../config/cities";
import {chartsRegionsApi} from "../../../components/map/api/charts_regions_api";
import {setChartsSelectedRegion, setMapCityPocCityQuery} from "../../../components/map/redux/map_city_poc_slice";
import {resolveMapRegionParamsFromSelection} from "../../../components/map/utils/resolve_map_region_params_from_selection";
import {AppDispatch} from "../../../store/store";

export const selectChartsCityBySlug = async (dispatch: AppDispatch, citySlug: CitySlug, label: string) => {
    const regionSlug = getCityOption(citySlug).requestMapSlug;
    const results = await dispatch(
        chartsRegionsApi.endpoints.getRegionAutocomplete.initiate({q: regionSlug, limit: 10})
    ).unwrap();
    const region = results.find((r) => r.slug === regionSlug);
    if (!region) {
        throw new Error(`Region not found for slug: ${regionSlug}`);
    }
    const mapParams = resolveMapRegionParamsFromSelection(region);

    dispatch(
        setChartsSelectedRegion({
            regionId: region.id,
            slug: region.slug,
            citySlug,
            label,
            hasChartsAccess: region.has_charts_access,
            ...mapParams
        })
    );
    dispatch(setMapCityPocCityQuery(citySlugToInvestmentsMapCityQuery(citySlug)));
};
